import React, { useState } from "react";
import { registerUser } from "../api/authApi";

export default function Register({ onRegisterSuccess, onShowLogin }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!name.trim() || !phone.trim() || !password.trim()) {
      setError("لطفاً نام، شماره موبایل و رمز عبور را وارد کنید");
      return;
    }

    if (password.length < 6) {
      setError("رمز عبور باید حداقل ۶ کاراکتر باشد");
      return;
    }

    if (password !== confirmPassword) {
      setError("تکرار رمز عبور با رمز عبور یکسان نیست");
      return;
    }

    setLoading(true);
    try {
      const data = await registerUser({
        name: name.trim(),
        phone: phone.trim(),
        password: password.trim(),
      });

      if (data?.token) {
        document.cookie = `token=${data.token}; path=/; max-age=${60 * 60 * 24 * 7}`;
      }

      onRegisterSuccess(data);
    } catch (err) {
      setError(err.message || "خطا در ثبت‌نام. لطفاً دوباره تلاش کنید.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-surface px-4 py-10"
      dir="rtl"
    >
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-2xl text-white">
            🚗
          </div>
          <h1 className="text-2xl font-extrabold text-navy">قولنامه هوشمند</h1>
          <p className="mt-1 text-sm text-gray-500">قرارداد ۲۴</p>
        </div>

        <div className="rounded-2xl bg-white p-6 shadow-card">
          <h2 className="mb-6 text-center text-base font-bold text-navy-light">
            ثبت‌نام در سیستم
          </h2>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <label className="text-xs font-bold text-gray-600">
                نام و نام خانوادگی
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="نام کامل"
                className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 outline-none transition focus:border-sky focus:bg-white focus:ring-2 focus:ring-sky/20"
                autoComplete="name"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-xs font-bold text-gray-600">
                شماره موبایل
              </label>
              <input
                type="tel"
                inputMode="numeric"
                dir="ltr"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="09xxxxxxxxx"
                className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 outline-none transition focus:border-sky focus:bg-white focus:ring-2 focus:ring-sky/20"
                autoComplete="tel"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-xs font-bold text-gray-600">
                رمز عبور
              </label>
              <input
                type="password"
                dir="ltr"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="حداقل ۶ کاراکتر"
                className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 outline-none transition focus:border-sky focus:bg-white focus:ring-2 focus:ring-sky/20"
                autoComplete="new-password"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-xs font-bold text-gray-600">
                تکرار رمز عبور
              </label>
              <input
                type="password"
                dir="ltr"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="تکرار رمز عبور"
                className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 outline-none transition focus:border-sky focus:bg-white focus:ring-2 focus:ring-sky/20"
                autoComplete="new-password"
              />
            </div>

            {error && (
              <div className="rounded-xl border border-red-100 bg-red-50 px-4 py-2.5 text-xs font-bold text-red-600">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="mt-1 w-full rounded-xl bg-navy py-3 text-sm font-bold text-white transition hover:bg-navy-light disabled:cursor-not-allowed disabled:opacity-60"
            >
              {loading ? "در حال ثبت‌نام..." : "ثبت‌نام"}
            </button>
          </form>

          <div className="mt-5 border-t border-gray-100 pt-4 text-center text-xs text-gray-500">
            قبلاً ثبت‌نام کرده‌اید؟{" "}
            <button
              type="button"
              onClick={onShowLogin}
              className="font-bold text-sky transition hover:text-sky-dark"
            >
              ورود به حساب
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
